import { StudyPlanModel } from '@/models/kingslanding/studyPlanModel';

export interface StudyPlanState {
  studyPlans: { [key: string]: StudyPlanModel };
  isLoadingStudyPlan: boolean;
  loadedActivities: number[];
  currentStudyPlanDisplayed: string;
  currentWeek: number;
  lastNextWeekLoaded: number;
  lastPreviousWeekLoaded: number;
}

const state: StudyPlanState = {
  studyPlans: {},
  loadedActivities: [],
  isLoadingStudyPlan: false,
  currentStudyPlanDisplayed: '',
  currentWeek: -1,
  lastNextWeekLoaded: -1,
  lastPreviousWeekLoaded: -1,
};

export default state;
